import dynamic from 'next/dynamic';
import { View } from 'react-native';

import LoadingContent from '~/components/Library/LoadingContent';
import NotFoundContent from '~/components/NotFoundContent';
import { type LibraryType } from '~/types';
import tw from '~/util/tailwind';

type Props = {
  libraries: LibraryType[];
};

const LibraryWithLoading = dynamic(() => import('~/components/Library'), {
  loading: () => <LoadingContent />,
});

export default function Libraries({ libraries }: Props) {
  if (!libraries || !libraries.length) {
    return <NotFoundContent />;
  }

  return (
    <View style={tw`pt-3`}>
      {libraries.map((item, index) => (
        <LibraryWithLoading key={`list-item-${index}-${item.github.name}`} library={item} />
      ))}
    </View>
  );
}
